import React, {useEffect} from "react";
import {graphql} from "gatsby";
import {Trans} from "@lingui/macro";
import BaseLayout from "../layouts/base";
import SEO from "../components/seo";
import {Nav} from "../components/nav";
import {Typography} from "../components/typography";
import {useNamedUrls} from "../hooks/named-urls";
// blocks
import HorizontalContentBlock from "../components/content-block-horizontal";
import FeatureHighlightsBlock from "../components/blocks/feature-highlights-block";
import BottomFeaturesBlock from "../components/blocks/bottom-features-block";
import TopFeatureBlock from "../components/blocks/top-feature-block";


const FeaturePage = ({data}) => {
  const {signup, bookCall} = useNamedUrls();
  const {featuresYaml: {meta, blocks}} = data;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    });
  }, [data]);

  return (
    <BaseLayout>
      <SEO {...meta} />

      <HorizontalContentBlock
        contentPosition="right"
        titleElement={Typography.MainTitle}
        footer={
          <Nav.Button to={signup} color="cyan" size="large">
            <Trans>Start for Free</Trans>
          </Nav.Button>
        }
        {...blocks.overview}
      />

      {blocks.features && (
        <FeatureHighlightsBlock {...blocks.features} />
      )}

      {blocks.content2 && (
        <TopFeatureBlock contentPosition='right'
                         mode='transparent'
                         {...blocks.content2} />
      )}

      {blocks.content1 && (
        <TopFeatureBlock contentPosition='left'
                         callToAction={
                           <Nav.Button to={bookCall} color="cyan" size="large">
                             <Trans>Request Demo</Trans>
                           </Nav.Button>
                         }
                         {...blocks.content1} />
      )}

      {/*{!blocks.testimonial?.hidden && <TestimonialBlock {...blocks.testimonial} />}*/}
      {blocks.bottomFeatures && (
        <BottomFeaturesBlock {...blocks.bottomFeatures} />
      )}
    </BaseLayout>
  );
};

export default FeaturePage;

export const query = graphql`
  query ($slug: String!, $locale: String!) {
    featuresYaml(slug: { eq: $slug }, lang: { eq: $locale }) {
      lang
      meta {
        title
        description
        keywords
      }
      blocks {
        overview {
          title
          subtitle
          content
          media {
            alt
            image {
              childImageSharp {
                gatsbyImageData(height: 600)
              }
            }
            vector { publicURL }
          }
        }
        features {
          supTitle
          title
          content
          media {
            alt
            style
            image {
              childImageSharp {
                gatsbyImageData(height: 600)
              }
            }
            background {
              style
              color 
            }
          }
          items {
            icon {
              publicURL
            }
            title
            text
          }
        }
        content1 {
          contentPosition
          title
          content
          media {
            alt
            style
            vector { publicURL }
            image {
              childImageSharp {
                gatsbyImageData(height: 600)
              }
            }
          }
          list {
            color
            items
          }
        }
        content2 {
          title
          content
          media {
            alt
            image {
              childImageSharp {
                gatsbyImageData(height: 600)
              }
            }
          }
          list {
            color
            items
          }
        }
        testimonial {
          hidden
          media {
            alt
            image {
              childImageSharp {
                gatsbyImageData(width: 500)
              }
            }
          }
          text
          title
          by {
            name
            job
            customer
          }
        }
        bottomFeatures {
          title
          list {
            color
            items
          }
        }
      }
    }
  }
`;
